import { CmsApiFlashCardQuizBlockData } from 'modules/cms/api/types/CmsApiFlashCardQuiz';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpFlashCardQuizBlock } from './CmsAmpFlashCardQuizBlock';
import { CmsFlashCardQuizBlock } from './CmsFlashCardQuizBlock';

export const CmsFlashCardsQuizBlockMapping: CmsBlockMapping<CmsApiFlashCardQuizBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsFlashCardQuizBlock,
    AmpComponent: CmsAmpFlashCardQuizBlock,
  };
